import React__default from 'react';
import cn from 'classnames';
import { inheritsLoose as _inheritsLoose, objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import styles from 'ui-components/Carousel.scss';
import { Context } from './index.js';

var _excluded = ["icon"];
var ChevronIcon = /*#__PURE__*/React__default.createElement("svg", {
  fill: "currentColor",
  height: "6.61475",
  viewBox: "0 0 11.06445 6.61475",
  width: "11.06445",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React__default.createElement("path", {
  d: "m5.51 6.615-5.51-5.511 1.061-1.06 4.449 4.45 4.494-4.494 1.06 1.061z"
}));
var Arrows = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(Arrows, _React$Component);
  function Arrows() {
    return _React$Component.apply(this, arguments) || this;
  }
  var _proto = Arrows.prototype;
  _proto.render = function render() {
    if (!this.context && process.env.NODE_ENV !== "production") {
      console.error("<Arrows /> must be nested inside of a <Carousel />");
    }
    var _this$context = this.context,
      prev = _this$context.prev,
      next = _this$context.next;
    return /*#__PURE__*/React__default.createElement("div", this.props, /*#__PURE__*/React__default.createElement("button", {
      type: "button",
      "aria-label": "Previous item",
      className: styles.prev,
      onClick: function onClick() {
        return prev();
      }
    }, ChevronIcon), /*#__PURE__*/React__default.createElement("button", {
      type: "button",
      "aria-label": "Next item",
      className: styles.next,
      onClick: function onClick() {
        return next();
      }
    }, ChevronIcon));
  };
  return Arrows;
}(React__default.Component);
Arrows.contextType = Context;
var Dots = /*#__PURE__*/function (_React$Component2) {
  _inheritsLoose(Dots, _React$Component2);
  function Dots() {
    return _React$Component2.apply(this, arguments) || this;
  }
  var _proto2 = Dots.prototype;
  _proto2.render = function render() {
    if (!this.context && process.env.NODE_ENV !== "production") {
      console.error("<Dots /> must be nested inside of a <Carousel />");
    }
    var _this$context2 = this.context,
      numItems = _this$context2.numItems,
      slidesToScroll = _this$context2.slidesToScroll,
      current = _this$context2.current,
      setCurrent = _this$context2.setCurrent;
    var numPages = Math.ceil(numItems / slidesToScroll);
    return /*#__PURE__*/React__default.createElement("div", this.props, Array.from({
      length: numPages
    }, function (v, k) {
      return k;
    }).map(function (x) {
      var _cn;
      return /*#__PURE__*/React__default.createElement("button", {
        key: x,
        type: "button",
        "aria-label": "Goto item " + (x + 1),
        className: cn(styles.dot, (_cn = {}, _cn[styles.active] = current / slidesToScroll === x, _cn)),
        onClick: function onClick() {
          return setCurrent(x * slidesToScroll);
        }
      });
    }));
  };
  return Dots;
}(React__default.Component);
Dots.contextType = Context;
var Combined = /*#__PURE__*/function (_React$Component3) {
  _inheritsLoose(Combined, _React$Component3);
  function Combined() {
    return _React$Component3.apply(this, arguments) || this;
  }
  var _proto3 = Combined.prototype;
  _proto3.render = function render() {
    if (!this.context && process.env.NODE_ENV !== "production") {
      console.error("<Combined /> must be nested inside of a <Carousel />");
    }
    var _this$props = this.props,
      icon = _this$props.icon,
      props = _objectWithoutPropertiesLoose(_this$props, _excluded);
    var _this$context3 = this.context,
      numItems = _this$context3.numItems,
      slidesToScroll = _this$context3.slidesToScroll,
      current = _this$context3.current,
      setCurrent = _this$context3.setCurrent,
      next = _this$context3.next,
      prev = _this$context3.prev;
    var numPages = Math.ceil(numItems / slidesToScroll);
    var ButtonIcon = icon ? icon : ChevronIcon;
    return /*#__PURE__*/React__default.createElement("div", _extends({
      className: styles.combined
    }, props), /*#__PURE__*/React__default.createElement("button", {
      type: "button",
      "aria-label": "Previous item",
      className: styles.prev,
      onClick: function onClick() {
        return prev();
      }
    }, ButtonIcon), Array.from({
      length: numPages
    }, function (v, k) {
      return k;
    }).map(function (x) {
      var _cn2;
      return /*#__PURE__*/React__default.createElement("button", {
        key: x,
        type: "button",
        "aria-label": "Goto item " + (x + 1),
        className: cn(styles.dot, (_cn2 = {}, _cn2[styles.active] = current / slidesToScroll === x, _cn2)),
        onClick: function onClick() {
          return setCurrent(x * slidesToScroll);
        }
      });
    }), /*#__PURE__*/React__default.createElement("button", {
      type: "button",
      "aria-label": "Next item",
      className: styles.next,
      onClick: function onClick() {
        return next();
      }
    }, ButtonIcon));
  };
  return Combined;
}(React__default.Component);
Combined.contextType = Context;

export { Arrows, Combined, Dots };
//# sourceMappingURL=controls.js.map
